export default function createBillingsStoreErrors(errors) {
  return {
    date: errors.date,
    spent: errors.amount,
    fee: errors.fee,
    bonus: errors.bonus,
    paymentMethodCommission: errors.payment_method_commission,
  };
}
